module.exports = __webpack_public_path__ + "media/country_flags/id-8161cc39.png";